module.exports = __webpack_public_path__ + "img/LTC.90825280.png";